import gsap from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollToPlugin);

const prefersReducedMotion = () =>
    typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

export const scrollToSection = (id: string, { instant = false }: { instant?: boolean } = {}) => {
    if (!document.getElementById(id)) {
        return;
    }

    if (instant || prefersReducedMotion()) {
        gsap.set(window, { scrollTo: `#${id}` });

        return;
    }

    gsap.to(window, {
        scrollTo: { y: `#${id}`, autoKill: true },
        duration: 1,
        ease: 'power2.inOut',
        overwrite: 'auto',
    });
};
